<ng-container *ngIf="!loading && round">
  <div class="header" *ngIf="titleVisible">
    <div class="title">
      <a [routerLink]="tournamentRoute" class="name">{{ tournament.name }}</a>
      <a [routerLink]="tournamentRoute" class="btn-detail">Перейти</a>
    </div>
  </div>

  <div class="link-tabs" *ngIf="rounds.length > 0">
    <a
      *ngFor="let item of rounds"
      [routerLink]="[]"
      [queryParams]="getRoundQueryParams(item.id)"
      queryParamsHandling="merge"
      (click)="setRound(item)"
      [ngClass]="{active: round.id === item.id}"
    >{{ item.name }}</a>
  </div>

  <div class="round-content" *ngIf="!roundLoading">
    <ng-container *ngIf="round.divisions.length > 0">
      <div
        *ngFor="let division of round.divisions"
        class="item division"
        [ngClass]="{group: round.type === roundTypes.group, playoff: round.type === roundTypes.playoff}"
      >
        <div class="division-header" [ngStyle]="{backgroundUrl: 'url(' + division.cover.path + ')'}">
          <div class="name">{{ division.name }}</div>
          <a
            class="btn-detail"
            [routerLink]="tournamentRoute"
            [queryParams]="getDivisionQueryParams(division.id)"
            queryParamsHandling="merge"
          >Перейти</a>
        </div>
        <div class="content">
          <ng-container *ngIf="round.type === roundTypes.group">
            <div class="group" *ngFor="let group of divisionGroups[division.id]">
              <mtg-group-item
                [title]="divisionGroups[division.id].length > 1 ? group.name : 'Команды'"
                [group]="group"
                [tournament]="tournament"
                [tournamentRound]="round"
              ></mtg-group-item>
            </div>
          </ng-container>
          <ng-container *ngIf="round.type === roundTypes.playoff">
            <mtg-tournament-playoff-widget
              *ngFor="let playoff of divisionPlayoffs[division.id]"
              [playoff]="playoff"
              [titleVisible]="true"
              [sport]="tournament.sport"
            ></mtg-tournament-playoff-widget>
          </ng-container>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="round.divisions.length === 0">
      <ng-container *ngIf="round.type === roundTypes.group">
        <div class="item group" *ngFor="let group of groups">
          <mtg-group-item
            [group]="group"
            [tournament]="tournament"
            [tournamentRound]="round"
          ></mtg-group-item>
        </div>
      </ng-container>
      <ng-container *ngIf="round.type === roundTypes.playoff">
        <div class="item playoff" *ngFor="let playoff of playoffs">
          <mtg-tournament-playoff-widget
            [playoff]="playoff"
            [titleVisible]="true"
            [sport]="tournament.sport"
          ></mtg-tournament-playoff-widget>
        </div>
      </ng-container>
    </ng-container>
  </div>

  <div class="loading" *ngIf="roundLoading">
    <mtg-spinner></mtg-spinner>
  </div>
</ng-container>

<div class="loading" *ngIf="loading">
  <mtg-spinner></mtg-spinner>
</div>
